import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/product/discounts', config);
}

const get = async (id) => {
    return FinanceApi.get('/product/discounts/' + id);
}

const store = async (data) => {
    if (data.id) {
        return FinanceApi.put('/product/discounts/' + data.id, data);
    }
    return FinanceApi.post('/product/discounts', data);
}

const update = async (id, formData) => {
    return FinanceApi.put('/product/discounts/' + id, formData);
}

const deleteProductDiscount = async (code) => {
    return FinanceApi.delete('/product/discounts/' + code);
}

export default {
    getAll,
    get,
    store,
    update,
    deleteProductDiscount
}
